import { FooterStrip as Strip } from '../../components/Ads'
import { FooterStripWrap } from './FooterStrip.style'

export const FooterStrip = () => {
  const onRender = () => null
  return (
    <FooterStripWrap key={'footer-strip-ott'}>
      <Strip onAdRender={onRender} />
    </FooterStripWrap>
  )
}
